import React, { useState, useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import officePicture from '../../../assets/child-care.webp'

interface IntroductionProps {
    className?: string
}

export const ServicesIntroduction: React.FC<IntroductionProps> = ({ className }) => {
    const { t } = useTranslation()
    const [isExpanded, setIsExpanded] = useState(false)
    const [isMobile, setIsSmallWidth] = useState(false)

    useEffect(() => {
        const checkIfSmallWidth = () => {
            setIsSmallWidth(window.innerWidth < 1024)
        }

        checkIfSmallWidth()
        window.addEventListener('resize', checkIfSmallWidth)

        return () => window.removeEventListener('resize', checkIfSmallWidth)
    }, [])

    const toggleExpand = () => {
        setIsExpanded(!isExpanded)
    }
    return (
        <div
            className={`${className} container flex sm:flex-col-reverse lg:max-h-full
            sm:max-h-full
            xl:max-h-[850px]
        `}>
            <p
                className={`bg-primary-green text-white px-20 py-20 w-full flex flex-col justify-between
                sm:px-8 sm:py-5
                ${isExpanded ? 'sm:max-h-full' : 'sm:max-h-auto sm:overflow-hidden'}
                `}>
                <div>{t('servicesIntroduction.summary')}</div>
                <br />
                <div>
                    {t('servicesIntroduction.advantages.main')} {t('servicesIntroduction.advantages.details')}
                    {t('servicesIntroduction.advantages.equipment')}
                </div>
                <br />
                {(!isMobile || (isMobile && isExpanded)) && (
                    <>
                        <div>{t('servicesIntroduction.environment.description')}</div>
                        <br />
                        <div>
                            {t('servicesIntroduction.preoperative.search')}
                            {t('servicesIntroduction.preoperative.concerns')}
                            {t('servicesIntroduction.environment.anesthesia')}
                        </div>
                        <br />
                        <div>
                            {t('servicesIntroduction.postoperative.instructions')}
                            {t('servicesIntroduction.postoperative.contact')}
                            {t('servicesIntroduction.postoperative.concerns')}
                        </div>
                        <br />
                        <div>{t('servicesIntroduction.anesthesiaTeam')}</div>
                        <br />
                        <div>{t('servicesIntroduction.consultation')}</div>
                        <br />
                        <div>{t('servicesIntroduction.alternativeTreatment')}</div>
                    </>
                )}

                {isMobile && !isExpanded && (
                    <div className="text-center mt-4">
                        <button onClick={toggleExpand} className="bg-white text-primary-green px-4 py-2 rounded">
                            {t('servicesIntroduction.readMore')}
                        </button>
                    </div>
                )}
                {isMobile && isExpanded && (
                    <div className="text-center mt-4">
                        <button onClick={toggleExpand} className="bg-white text-primary-green px-4 py-2 rounded">
                            {t('servicesIntroduction.readLess')}
                        </button>
                    </div>
                )}
            </p>
            <img
                src={officePicture}
                alt="office"
                className={`w-1/3 object-cover max-h-full sm:w-full ${isExpanded ? 'sm:max-h-[400px]' : 'sm:max-h-[500px]'}`}
            />
        </div>
    )
}
